<template>
    <!-- <router-link to="/Homepage"></router-link> -->
  <router-view/>

</template>

<script>


export default {
  name: 'App',
}
</script>

<style>
body {
  background-color: #e1ebed;
}
#app {
  background-color: #e1ebed;
  font-family: 'Varela Round', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* margin-top: 60px; */
}
</style>
